import type { ApiOrder } from '../types';

/**
 * Mock dataset covering all five visible statuses (§2.9). Timestamps are
 * relative to "now" so the mock data stays realistic regardless of when
 * the screen is opened.
 */
export function buildMockOrders(now: number = Date.now()): ApiOrder[] {
  const ago = (mins: number) => new Date(now - mins * 60_000).toISOString();
  const ahead = (mins: number) => new Date(now + mins * 60_000).toISOString();

  return [
    {
      id: 'mock-001-pend',
      externalId: 'ext-mock-001-A1B2C',
      title: 'Lena',
      status: 'pending',
      createdAt: ago(2),
      updatedAt: ago(2),
      pickupAt: null,
    },
    {
      id: 'mock-002-recv',
      externalId: 'ext-mock-002-D3E4F',
      title: 'Marcus',
      status: 'received',
      createdAt: ago(5),
      updatedAt: ago(4),
      pickupAt: null,
    },
    {
      id: 'mock-003-prog',
      externalId: 'ext-mock-003-G5H6J',
      title: 'Sasha',
      status: 'in_progress',
      createdAt: ago(8),
      updatedAt: ago(1),
      pickupAt: null,
      priorityScore: 10,
    },
    {
      id: 'mock-004-prog',
      externalId: 'ext-mock-004-K7L8M',
      title: 'Avery',
      status: 'in_progress',
      createdAt: ago(10),
      updatedAt: ago(3),
      pickupAt: null,
      priorityScore: 80,
    },
    {
      id: 'mock-005-wait',
      externalId: 'ext-mock-005-N9P0Q',
      title: 'Jordan',
      status: 'waiting_for_pickup',
      createdAt: ago(12),
      updatedAt: ago(0),
      pickupAt: null,
    },
    {
      id: 'mock-006-wait',
      externalId: 'ext-mock-006-R1S2T',
      title: '', // exercises the "Guest" fallback
      status: 'waiting_for_pickup',
      createdAt: ago(15),
      updatedAt: ago(2),
      pickupAt: null,
    },
    {
      id: 'mock-007-done',
      externalId: 'ext-mock-007-U3V4W',
      title: 'Pat',
      status: 'completed',
      createdAt: ago(20),
      updatedAt: ago(5),
      pickupAt: ago(4),
    },
    {
      // Scheduled future order - should be hidden until 15min before pickup.
      id: 'mock-008-pend-future',
      externalId: 'ext-mock-008-X5Y6Z',
      title: 'Future Riley',
      status: 'pending',
      createdAt: ago(1),
      updatedAt: ago(1),
      pickupAt: ahead(60),
    },
  ];
}
